var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.accountCenterInfo.status !== "PASSED"
    ? _c(
        "div",
        {
          staticStyle: {
            "background-color": "#f4f7fa",
            "padding-top": "24px",
            "padding-bottom": "5px",
          },
        },
        [
          _vm.accountCenterInfo.status === "PENDING"
            ? _c("div", { staticClass: "topbox" }, [
                _vm._v(_vm._s(_vm.$t("components.webList.accountChecking"))),
              ])
            : _vm.accountCenterInfo.status === "FAILED"
            ? _c(
                "div",
                { staticClass: "topbox" },
                [
                  _c("i", {
                    staticClass: "pp-icon pp-icon-information-circled icontop",
                  }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("components.webList.accountNotAllow")) +
                      " "
                  ),
                  _c(
                    "pp-button",
                    {
                      staticClass: "btn",
                      attrs: { type: "primary", size: "spec" },
                      on: { click: _vm.updateuser },
                    },
                    [_vm._v(_vm._s(_vm.$t("components.webList.addAgain")))]
                  ),
                ],
                1
              )
            : _vm.accountCenterInfo.status === "EMPTY"
            ? _c(
                "div",
                { staticClass: "topbox" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("components.webList.accountNoAdd")) +
                      " "
                  ),
                  _c(
                    "pp-button",
                    {
                      staticClass: "btn",
                      attrs: { type: "primary", size: "spec" },
                      on: { click: _vm.updateuser },
                    },
                    [_vm._v(_vm._s(_vm.$t("components.webList.addNow")))]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }